import { formatSumFromObject } from '@utils/formatValues';
import BunchIcon from '@assets/icons/outline/git-fork.svg?react';
import FbpIcon from '@assets/icons/outline/circle-gauge.svg?react';
// import UnclaimedIcon from '@assets/icons/outline/square-arrow-left.svg?react';
import DropshippingIcon from '@assets/icons/outline/repeat.svg?react';
// import WarningIcon from '@assets/icons/outline/triangle-alert.svg?react';
import ReturnsIcon from '@assets/icons/outline/undo-2.svg?react';
import ParcelsIcon from '@assets/icons/outline/package-2.svg?react';
import ComplaintsIcon from '@assets/icons/outline/message-circle-warning.svg?react';
import PickUpIcon from '@assets/icons/outline/truck.svg?react';
import UniClubIcon from '@assets/icons/outline/gem.svg?react';
import FulfilmentIcon from '@assets/icons/outline/copy-plus.svg?react';
import SellersIcon from '@assets/icons/outline/store.svg?react';
import { TMenuItem } from "@components/new/Sidebar";
import { AccountResponse } from '@api/Responses/AccountResponse';

const getMenu = ({
  t,
  account,
  complaintsTotal,
  awaitingReturnsTotal,
  awaitingUnclaimedTotal,
  awaitingProblematicCustomsTotal,
  awaitingProblematicFirstMileTotal,
  // unclaimedReturnsCounter,
  cashbackData,
}: {
  t: (a: string, b?: any) => string;
  account?: AccountResponse;
  complaintsTotal?: number;
  awaitingReturnsTotal?: number;
  awaitingUnclaimedTotal?: number;
  awaitingProblematicCustomsTotal?: number;
  awaitingProblematicFirstMileTotal?: number;
  unclaimedReturnsCounter?: number;
  cashbackData?: any;
}): TMenuItem[] => {
  const { region } = account ?? {};
  return [
    {
      icon: SellersIcon,
      path: "/stores",
      title: t("navbar.stores"),
      id: "stores",
    },
    {
      icon: ParcelsIcon,
      path: "/parcels",
      title: t("navbar.parcels"),
      id: "parcels",
    },
    {
      icon: ReturnsIcon,
      path: '/returns',
      title: t('navbar.returns'),
      count: awaitingReturnsTotal,
      id: 'returns',
      subpages: [
        {
          id: 'clientReturn',
          title: t('navbar.clientReturn'),
          path: '/returns',
          count: awaitingReturnsTotal,
        },
        {
          id: 'unclaimedReturn',
          title: t('navbar.unclaimed'),
          path: '/unclaimed?tab=returns',
          count: awaitingUnclaimedTotal,
          // count: unclaimedReturnsCounter,
        },
        ...((region === "CN") ? [
          {
            id: "problematic",
            path: "/problematic-parcels",
            title: t("navbar.problematicParcels"),
            count: awaitingProblematicFirstMileTotal! + awaitingProblematicCustomsTotal!,
            // count: awaitingProblematicFirstMileTotal,
          }
        ] : []),
        // {
        //   id: 'FBPReturn',
        //   title: t('navbar.FBPReturn'),
        //   path: '/',
        // },
      ],
    },
    ...((region === "CN") ? [{
       icon: DropshippingIcon,
       path: "/labelling",
       title: t("navbar.dropshipping"),
       id: "labelling",
     }] : []),
     ...((region !== "CN") ? [{
       icon: FulfilmentIcon,
       path: "/fulfillment",
       title: t("navbar.fulfillment"),
       id: "fulfillment",
     },] : []),
     {
       icon: ComplaintsIcon,
       path: "/complaints",
       title: t("navbar.complaints"),
       id: "complaints",
       count: complaintsTotal,
     },
    ...((region === "CN") ? [
      {
        icon: PickUpIcon,
        path: "/pick-up",
        title: t("pickUp.title"),
        id: "pickup",
      },
    ] : []),
    ...((region === "CN") ? [
      {
        icon: FbpIcon,
        path: "/fbp",
        title: t("fbpPage.navTitle"),
        id: "fbp",
      },
    ] : []),
    {
      icon: BunchIcon,
      path: "/bunch",
      title: t("bunchPage.title"),
      id: "bunch",
    },
    ...((region === "TR") ? [
      {
        icon: UniClubIcon,
        path: "/uni-club",
        title: t("uniClub.title"),
        id: "uniClub",
        count: cashbackData ? formatSumFromObject(cashbackData) : "",
      },
    ] : []),
  ]
}

export default getMenu;
